import React, { useMemo } from "react";
import { useTable, useSortBy, useFilters } from "react-table";

import SreoTextFilter from "./SreoTextFilter";

/*
 * https://www.akashmittal.com/react-table-learn-filter-sort-pagination-in-10-minutes/
 *  Primarily used the above tutorial to get through this.
 */
export default function SreoScreenerTable({ columns, data, showFilter }) {
  const defaultColumn = useMemo(
    () => ({
      Filter: SreoTextFilter
    }),
    []
  );

  const filterTypes = useMemo(
    () => ({
      text: (rows, id, filterValue) => rows.filter(row => {
        const rowValue = row.values[id];

        return rowValue !== undefined ?
          String(rowValue)
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase()) :
          true;
      }),
      number: (rows, id, filterValue) => rows.filter(row => {
        const rowValue = row.values[id];

        return rowValue !== undefined ?
          String((rowValue * 100.00).toFixed(2))
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase()) :
          true;
      })
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data,
    disableSortRemove: true,
    defaultColumn,
    filterTypes
  }, useFilters, useSortBy);

  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>
                <div {...column.getSortByToggleProps()}>
                  {column.render("Header")}
                </div>
                <div>{column.canFilter && showFilter ? column.render("Filter") : null}</div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);

          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => <td style={{ minWidth: `${cell.column.width ? cell.column.width : 170}px` }} {...cell.getCellProps()}>{cell.render("Cell")}</td>)}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
